import {
  AwardIcon,
  CalendarIcon,
  ClipboardCheckIcon,
  ClipboardListIcon,
  FileTextIcon,
  FilePenLine,
  Gift,
  HelpCircle,
  LayoutDashboardIcon,
  PieChart,
  SearchIcon,
  SettingsIcon,
  ShieldCheckIcon,
  TagIcon,
  Users,
} from "lucide-react"

interface BreadcrumbItem {
  title: string
  link: string
}

export const routeMapping: Record<string, BreadcrumbItem[]> = {
  '/dashboard': [{ title: 'Dashboard', link: '/dashboard' }],
  '/calendar': [
    { title: 'Training & Events', link: '/calendar' },
  ],
  '/cpd-bank': [
    { title: 'CPD Bank', link: '/cpd-bank' },
  ],
  '/benefits': [
    { title: 'Benefits Journey', link: '/benefits' },
  ],
  '/membership/categories': [
    { title: 'Membership', link: '/membership' },
    { title: 'Categories', link: '/membership/categories' },
  ],
  '/membership/documents': [
    { title: 'Membership', link: '/membership' },
    { title: 'Essential Documents', link: '/membership/documents' },
  ],
  '/membership/applications': [
    { title: 'Membership', link: '/membership' },
    { title: 'My Applications', link: '/membership/applications' },
  ],
  '/membership/profile': [
    { title: 'Membership', link: '/membership' },
    { title: 'Edit Application', link: '/membership/profile' },
  ],
  '/settings/categories': [
    { title: 'Settings', link: '/settings' },
    { title: 'Categories', link: '/settings/categories' },
  ],
  '/settings/requirements': [
    { title: 'Settings', link: '/settings' },
    { title: 'Requirements', link: '/settings/requirements' },
  ],
  '/settings/benefits-config': [
    { title: 'Settings', link: '/settings/benefits-config' },
    { title: 'Benefits Configuration', link: '/settings/benefits-config' },
  ],
  '/admin/applications': [
    { title: 'Administration', link: '/admin/applications' },
    { title: 'Applications', link: '/admin/applications' },
  ],
  '/admin/approved-applications': [
    { title: 'Administration', link: '/admin/approved-applications' },
    { title: 'Members', link: '/admin/approved-applications' },
  ],
  '/admin/renewals': [
    { title: 'Administration', link: '/admin/renewals' },
    { title: 'Renewals', link: '/admin/renewals' },
  ],
  '/admin/reports': [
    { title: 'Administration', link: '/admin/reports' },
    { title: 'Reports', link: '/admin/reports' },
  ],
  '/admin/birthdays': [
    { title: 'Administration', link: '/admin/birthdays' },
    { title: 'Birthdays', link: '/admin/birthdays' },
  ],
  '/training-needs': [
    { title: 'Training Needs', link: '/training-needs' },
  ],
  '/communities': [
    { title: 'Communities', link: '/communities' },
  ],
  '/notifications': [
    { title: 'Notifications', link: '/notifications' },
  ],
}

export const navItems = {
  user: {
    name: 'Admin',
    email: 'info@uibfs.or.ug',
    avatar: '/avatars/shadcn.jpg',
  },
  navMain: [
    {
      title: 'Dashboard',
      url: '/dashboard',
      icon: LayoutDashboardIcon,
    },
    {
      title: 'My Applications',
      url: '/membership/applications',
      icon: FilePenLine,
    },
    {
      title: 'My Renewals',
      url: '/membership/renewals',
      icon: ClipboardCheckIcon,
    },
    // {
    //   title: 'Notifications',
    //   url: '/notifications',
    //   icon: Bell,
    // },
    {
      title: 'Training Needs',
      url: '/training-needs',
      icon: ClipboardListIcon,
      roles: ['admin', 'orgAdmin'] as const,
    },
  ],
  navCollapsible:[
    {
      title: 'Benefits Journey',
      url: '/benefits',
      icon: Gift,
      defaultOpen: true,
      autoOpenOnActive: true,
      items: [
        {
          title: 'Overview',
          url: '/benefits/overview',
          icon: Gift,
        },
        {
          title: 'CPD Bank',
          url: '/benefits/cpd-bank',
          icon: AwardIcon,
        },
        {
          title: 'Training & Events',
          url: '/benefits/calendar',
          icon: CalendarIcon,
        },
        {
          title: 'Essential Documents',
          url: '/benefits/documents',
          icon: FileTextIcon,
        },
        {
          title: 'Communities',
          url: '/benefits/communities',
          icon: Users,
        },
      ],
    },
  ],
  navSecondary: [
    {
      title: 'Settings',
      url: '#',
      icon: SettingsIcon,
    },
    {
      title: 'Get Help',
      url: '#',
      icon: HelpCircle,
    },
    {
      title: 'Search',
      url: '#',
      icon: SearchIcon,
    },
  ],
  navSettings: [
    {
      title: 'Administration',
      url: '/admin',
      icon: ShieldCheckIcon,
      defaultOpen: true,
      autoOpenOnActive: true,
      items: [
        {
          title: 'CPD Registrations',
          url: '/admin/cpd-registrations',
          icon: CalendarIcon,
        },
        {
          title: 'Applications',
          url: '/admin/applications',
          icon: ClipboardListIcon,
        },
        {
          title: 'Members',
          url: '/admin/approved-applications',
          icon: ShieldCheckIcon,
        },
        {
          title: 'Renewals',
          url: '/admin/renewals',
          icon: ClipboardCheckIcon,
        },
        {
          title: 'Birthdays',
          url: '/admin/birthdays',
          icon: Gift,
        },
        {
          title: 'Reports',
          url: '/admin/reports',
          icon: PieChart,
        },
        // {
        //   title: 'User Insights',
        //   url: '/admin/insights',
        //   icon: LayoutDashboardIcon,
        // }
      ],
    },
    {
      title: 'Settings',
      url: "/settings",
      icon: SettingsIcon,
      items: [
        {
          title: 'Categories',
          url: '/settings/categories',
          icon: TagIcon,
        },
        {
          title: 'Requirements',
          url: '/settings/requirements',
          icon: ClipboardCheckIcon,
        },
        {
          title: 'Benefits Config',
          url: '/settings/benefits-config',
          icon: Gift,
        },
      ],

    },
  ],
}
